import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

function Supplies() {
  const [supplies, setSupplies] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);
  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Marca',
      field: 'band',
      hideFilterIcon: true,
    },
    // {
    //     title: "Unidade de padrão de consumo",
    //     field: "unity",
    //     hideFilterIcon: true,
    // },
    {
      title: 'Tipo',
      field: 'type.name',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/supplies');
        await response.data.map((supply) => {
          if (supply.description && supply.description.length > 15) {
            supply.description = `${supply.description.substr(0, 15)}...`;
          }
          return null;
        });

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setSupplies(response.data);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    supplies.map((supplie) => (
      supplie.id === newData.id ? tempData.push(newData) : tempData.push(supplie)
    ));
    setSupplies(tempData);
  }
  return (
    <Table title="Insumos" route="/supplies/" routeAdd="/supply/" columns={columns} data={supplies} setData={setData} dataLoaded={openProgress} />
  );
}

export default Supplies;
